import React from 'react';

import { formatNumber, ratio } from '../utils';

const HumidityRing: React.FC<{ value: number | null }> = ({ value }) => {
    const r = 27;
    const circumference = 2 * Math.PI * r;
    const fill = ratio(value, 0, 100);

    return (
        <div className="ring">
            <svg viewBox="0 0 64 64" aria-hidden="true">
                <circle cx="32" cy="32" r={r} className="ring-track" />
                <circle cx="32" cy="32" r={r} className="ring-fill"
                    transform="rotate(-90 32 32)"
                    strokeDasharray={circumference}
                    strokeDashoffset={circumference * (1 - fill)} />
            </svg>
            <span className="ring-label">{formatNumber(value, 0)}<small>%</small></span>
        </div>
    );
};

export default HumidityRing;
